export const AUTO_FIND_SUCCESS_CAPS = {
  discover: 25,
  free: 25,
  starter: 25,
  growth: 30,
  scale: 40,
} as const;

export const PAID_AUTO_MONTHLY_POOL_RATIO = 0.4;

export type AutoFindCapPlan = keyof typeof AUTO_FIND_SUCCESS_CAPS;

export const getAutoFindSuccessCap = (planName: string | null | undefined): number => {
  const normalizedPlan = (planName || 'discover').toLowerCase() as AutoFindCapPlan;
  return AUTO_FIND_SUCCESS_CAPS[normalizedPlan] ?? AUTO_FIND_SUCCESS_CAPS.discover;
};
